import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import AllExpenses from "../../components/user/expenses/AllExpenses";


function Expenses() {

  return (
    <>
      <AppWrapper
        pagename={"expenses"}
      >
        <StyledExpenses>
          <Title title={"Expenses"} btnName={""} />
        </StyledExpenses>

        <AllExpenses />


      </AppWrapper>

    </>
  );
}

export default Expenses;

const StyledExpenses = styled.div`
  

`;